import { date } from "yup";
import { store } from "../storeConfig/store";

export const onHeaderCheckboxClickHandler = (data, target) => {
  return async (dispatch, getState) => {
    const selectToggle = getState().select[target].selectAll ? false : true;
    const selectionData = [];
    if (selectToggle) {
      data &&
        data.forEach((item) => {
          selectionData.push(item.id);
        });
    }
    dispatch({
      type: "SET_SELECTION",
      payload: { data: selectionData, target },
    });
    dispatch({
      type: "SET_SELECTALL",
      payload: { data: selectToggle, target },
    });
  };
};

export const clearSelection = (target) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_SELECTION",
      payload: { data: [], target },
    });
    dispatch({
      type: "SET_SELECTALL",
      payload: { data: false, target },
    });
  };
};
export const checkboxOnClickHandler = (id, data, target) => {
  //console.log('i am called with value', id, data, target);
  return async (dispatch, getState) => {
    let selectionData = [...getState().select[target].selection];
    // //console.log(selectionData);
    //console.log('value of selection data', selectionData);
    let keyIndex = selectionData.indexOf(id);
    if (keyIndex >= 0) {
      selectionData = [
        ...selectionData.slice(0, keyIndex),
        ...selectionData.slice(keyIndex + 1),
      ];
    } else {
      selectionData.push(id);
    }
    if (selectionData.length === data.length) {
      dispatch({
        type: "SET_SELECTALL",
        payload: { data: true, target },
      });
    } else {
      dispatch({
        type: "SET_SELECTALL",
        payload: { data: false, target },
      });
    }
    dispatch({
      type: "SET_SELECTION",
      payload: { data: selectionData, target },
    });
  };
};
export const checkCheckedSelection = (id, target) => {
  // console.log("i am called with value", id, target);
  let selectionData = [...store.getState().select[target].selection];
  let keyIndex = selectionData.indexOf(id);
  if (keyIndex >= 0) return true;
  else return false;
};
